import React, {FC} from "react"

import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import ToastAlert from "@irati/ui/src/ToastAlert"
import {triggerSuccessToast} from "@irati/ui/src/ToastAlert/triggerToast"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {MobileOnlyWrapper} from "./styled"

interface Props {
  onConfirm?: () => void
  confirmText?: string
  confirmLoad?: Promise<any> | null
  disabledSave?: boolean
}

const SaveAndProgressMobile: FC<Props> = ({onConfirm, confirmText, disabledSave, confirmLoad}) => {
  const {formatMessage} = useIntl()
  const handleCopyLink = async () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      triggerSuccessToast(formatMessage({id: "platform.selfSignUp.welcome.copyLinkMessage"}))
    })
  }

  return (
    <>
      <ToastAlert />
      <MobileOnlyWrapper>
        <Flex direction="column" padding={[0, 2]}>
          {onConfirm && (
            <Button primary onClick={onConfirm} full marginTop={2} marginBottom={3} disabled={disabledSave} load={confirmLoad}>
              {confirmText}
            </Button>
          )}
          <Button tertiary onClick={handleCopyLink} full marginBottom={3}>
            <Icon icon={IconTypes.files} size={20} />
            <FormattedMessage id="platform.selfSignUp.welcome.popUp.copyLink" />
          </Button>
        </Flex>
      </MobileOnlyWrapper>
    </>
  )
}

export default SaveAndProgressMobile
